/** The prototype's "Copy Markdown" fallback when the clipboard is not available: the text, selected. */

import { useEffect, useRef } from 'react';
import { DialogFrame, type DialogProps } from '../app/dialogs.js';

export function CopyMarkdownDialog({ close, dialogId, text }: DialogProps & { text: string }) {
  const ref = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    ref.current?.select();
  }, []);
  return (
    <DialogFrame title="Copy Markdown" onClose={close} dialogId={dialogId}>
      <textarea id="markdown-copy" ref={ref} readOnly rows={12} value={text} />
      <p className="field-help">Select the text and copy it.</p>
      <div className="dialog-footer">
        <button type="button" className="primary-button" onClick={() => ref.current?.select()}>
          Select all
        </button>
      </div>
    </DialogFrame>
  );
}
